module.exports = __webpack_public_path__ + "img/specification.eb4cd091.svg";